const styles = theme => ({
  root: {
    paddingLeft: 4,
    paddingRight: 8,
    display:'flex',
    '& a':{
      color: 'white',
      textDecoration: 'none',
      marginRight:'4px',
      display: 'inline-block',
    },
    '& span': {
      color:'white',
      display: 'inline-block',
      lineHeight: '24px',
      height: '24px',
    },
    '& p':{
      display:'inline-block',
      lineHeight: '24px',
      height: '24px',
    }
  },
  button: {
    backgroundColor: theme.palette.accent,
    color: 'white',
  }
})

export default styles
